import { Linking } from 'react-native'
import styled, { useTheme } from 'styled-components'
import { Button } from '../../../elements/controls/index.js'

const SmallButton = styled(Button)`
  margin-bottom: 0;
  padding: ${(props) => props.theme.spacing.small}px ${(props) => props.theme.spacing.smedium}px;
  background: ${(props) => props.theme.colors.primary};
`

export const AdCTAButton = ({ title, url }) => {
  const theme = useTheme()

  return (
    <SmallButton
      title={title}
      onPress={() => Linking.openURL(url)}
      fontStyle={{
        fontSize: theme.fontSizes.small,
        textTransform: 'uppercase',
      }}
    />
  )
}
